export const gridColumnMenuSelector = state => state.columnMenu;